import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../lib/i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("bb_lang");
    if (saved && translations[saved]) return saved;
    return "it";
  });

  useEffect(() => {
    localStorage.setItem("bb_lang", lang);
    document.documentElement.lang = lang;
    // Update <title> and <meta description> per language for better SEO
    const meta = {
      it: { title: "B&B Emmanuel — Reggio Calabria · Sul Lungomare più bello d'Italia", desc: "B&B a Reggio Calabria. 5 camere, da €79/notte. Prenotazione diretta · miglior prezzo garantito." },
      en: { title: "B&B Emmanuel — Reggio Calabria · Italy's most beautiful seafront", desc: "B&B in Reggio Calabria. 5 rooms, from €79/night. Direct booking · best price guaranteed." },
      de: { title: "B&B Emmanuel — Reggio Calabria · Italiens schönste Promenade", desc: "B&B in Reggio Calabria. 5 Zimmer, ab €79/Nacht. Direktbuchung · bester Preis garantiert." },
      fr: { title: "B&B Emmanuel — Reggio Calabria · La plus belle promenade d'Italie", desc: "B&B à Reggio Calabria. 5 chambres, dès €79/nuit. Réservation directe · meilleur prix garanti." },
    }[lang] || {};
    if (meta.title) document.title = meta.title;
    if (meta.desc) {
      const mDesc = document.querySelector('meta[name="description"]');
      if (mDesc) mDesc.setAttribute("content", meta.desc);
      const mOg = document.querySelector('meta[property="og:description"]');
      if (mOg) mOg.setAttribute("content", meta.desc);
    }
  }, [lang]);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
